<template>
  <div class="text-align-c">
      <div class="content">----404----</div>
    <!--<div style="font-weight: bold;font-size: 20px;">页面不存在</div>-->



  </div>
</template>

<script>
  export default {
    name: "index"
  }
</script>

<style scoped>
  .content{
    /*text-align: center;*/
    font-weight: bold;
    font-size: 60px;
    padding-top: 100px;
  }

</style>
